@if (announces?.myNotificationsUnread?.length > 0) {
<div class="announces-banner">
  <button type="button" class="announces-banner-summary" (click)="toggle()">
    <i class="fal fa-bell"></i>
    <span>
      <b>{{ announces.myNotificationsUnread.length }}</b>
      annonce{{ announces.myNotificationsUnread.length > 1 ? 's' : '' }} non lue{{ announces.myNotificationsUnread.length > 1 ? 's' : '' }}
      — {{ announces.myNotificationsUnread[0].title }}
    </span>
    <i class="fal announces-banner-chevron" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>
  @if (expanded) {
  <ul class="announces-banner-list">
    @for (a of announces.myNotificationsUnread; track a.id) {
    <li>
      <a class="announces-banner-item-link" [routerLink]="['/annonce', a.id]">{{ a.title }}</a>
      <button type="button" class="announces-banner-mark-read" title="Marquer comme lue" (click)="markAsRead(a)">
        <i class="fal fa-check"></i>
      </button>
    </li>
    }
  </ul>
  <a class="announces-banner-viewall" [routerLink]="['/annonce']">Voir toutes les annonces →</a>
  }
</div>
}
